import script from "./TncBgView.vue?vue&type=script&setup=true&lang=js"
export * from "./TncBgView.vue?vue&type=script&setup=true&lang=js"

import "./TncBgView.vue?vue&type=style&index=0&id=b54e5c76&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b54e5c76"]])

export default __exports__